import { initSentry } from './src/lib/sentry';
initSentry();

import * as Sentry from '@sentry/react';
import { ViteReactSSG } from 'vite-react-ssg';
import App from './App';
import { initDevNetworkMonitor } from './lib/devNetworkMonitor';

// Initialize dev-only network monitoring (browser only, tree-shaken in production)
if (typeof window !== 'undefined') {
  initDevNetworkMonitor();
}

/**
 * Single catch-all route for vite-react-ssg's StaticRouter.
 *
 * IMPORTANT: Every route must render <App />, which delegates to its own
 * internal React Router <Routes> in AppRoutes.  Specific paths MUST NOT be
 * listed here because vite-react-ssg uses React Router's data-router API
 * (createStaticRouter/createBrowserRouter).  When a specific path like
 * "/about" is matched by the outer data-router, React Router sets
 * pathnameBase = "/about" on the route context.  The inner <Routes> in
 * AppRoutes then strips that prefix before matching, leaving only "/", which
 * always resolves to <LandingPage> — every non-home page renders the wrong
 * component in static HTML.
 *
 * With a single wildcard route, pathnameBase is always "/", so the inner
 * <Routes> receives the full pathname and matches correctly.
 *
 * Actual paths to pre-render are controlled by ssgOptions.includedRoutes
 * in vite.config.ts — this array only controls which element renders.
 */
const routes = [
  {
    path: '*',
    element: (
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    ),
  },
];

export const createRoot = ViteReactSSG(
  { routes },
  async ({ isClient }) => {
    // Server-side: nothing extra needed — SSG data is injected via
    // onBeforePageRender in vite.config.ts and read by getSSGPageData()
    if (!isClient) return;
  },
);
